var ReleaseSeatsPassengersScreen = (function ($) {

    ReleaseSeatsPassengersScreen = function (options) {
        var that = this;

        options = options || {};

        // CONST
        that.modals = options['modals'] || {};
        that.passengers_category_types = options['passengers_category_types'] || [];
        that.locales = options['locales'] || {};
        that.class = {
            disabled: 'disabled',
            selected: 'selected',
            hidden: 'hidden',
            error: 'error'
        };
        that.selectors = {
            select_passenger: '.js-select-passenger',
            select_passenger_action_select: '.js-select-passenger-action-select',
            warning_forgotten_infants: '.js-warning-forgotten-infants'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$select_passenger = that.$wrapper.find(that.selectors.select_passenger);
        that.$select_passenger_action_select = that.$wrapper.find(that.selectors.select_passenger_action_select);

        // INIT
        that.init();
    };

    ReleaseSeatsPassengersScreen.prototype.init = function () {
        var that = this;

        that.__initEvents();
    };

    /**
     * @returns {boolean}
     */
    ReleaseSeatsPassengersScreen.prototype.isValid = function () {
        var that = this;

        if (that.$select_passenger_action_select.filter(':checked').length === 0) {
            that.$select_passenger.addClass(that.class.error).siblings('.error').text(that.locales.passenger_not_selected);
            return false;
        }

        if (!that.__checkAllInfantsFlyingWithAdults()) {
            $.uiModal({
                html: that.modals['forgotten_infant']
            });
            return false;
        }

        return true;
    };

    ReleaseSeatsPassengersScreen.prototype.getData = function () {
        var that = this,
            selected_passenger_hashes = [];

        that.$select_passenger_action_select.filter(':checked').each(function () {
            selected_passenger_hashes.push($(this).parents(that.selectors.select_passenger).data('passenger-hash'));
        });

        return {
            value: selected_passenger_hashes
        };
    };

    /**
     * @private
     */
    ReleaseSeatsPassengersScreen.prototype.__initEvents = function () {
        var that = this;

        that.$select_passenger.on('click', function () {
            var $passenger = $(this),
                $input = $passenger.find(that.selectors.select_passenger_action_select),
                is_checked = !$input.prop('checked');

            if (!$passenger.hasClass(that.class.disabled)) {
                $input.prop('checked', is_checked).toggleClass(that.class.selected, is_checked);
                $passenger.toggleClass(that.class.selected, is_checked);
            }

            if (that.$select_passenger_action_select.filter(':checked').length > 0) {
                that.$select_passenger.removeClass(that.class.error);
                that.$wrapper.find(that.selectors.warning_forgotten_infants).toggleClass(that.class.hidden, that.__checkAllInfantsFlyingWithAdults());
            } else {
                that.$wrapper.find(that.selectors.warning_forgotten_infants).addClass(that.class.hidden);
            }
        });
    };

    /**
     * @returns {boolean}
     * @private
     */
    ReleaseSeatsPassengersScreen.prototype.__checkAllInfantsFlyingWithAdults = function () {
        var that = this,
            adults_selected_count = 0,
            adults_unselected_count = 0,
            youth_selected_count = 0,
            children_selected_count = 0,
            children_unselected_count = 0,
            infants_selected_count = 0,
            has_child = false;

        that.passengers_category_types.forEach(function (passenger) {
            var is_checked = that.$wrapper.find('[data-passenger-hash="' + passenger.hash + '"] ' + that.selectors.select_passenger_action_select).prop('checked');
            if (true === passenger.is_adult) {
                if (false === is_checked) {
                    adults_unselected_count++;
                } else {
                    adults_selected_count++;
                }
            } else if (true === passenger.is_youth) {
                if (true === is_checked) {
                    youth_selected_count++;
                }
            } else {
                has_child = true;
                if (false === is_checked) {
                    children_unselected_count++;
                } else {
                    children_selected_count++;
                    if (true === passenger.is_infant) {
                        infants_selected_count++;
                    }
                }
            }
        });

        if (!has_child || (youth_selected_count > 0 && adults_selected_count === 0 && children_selected_count === 0)) {
            return true;
        }

        if (infants_selected_count > adults_selected_count * 2) {
            return false;
        }

        return adults_selected_count > 0 && (children_unselected_count === 0 || (adults_unselected_count > 0 && children_unselected_count > 0));
    };

    // EVENTS

    ReleaseSeatsPassengersScreen.prototype.beforeUnload = function () {
        var that = this;

        that.$select_passenger.addClass(that.class.disabled);
    };

    ReleaseSeatsPassengersScreen.prototype.afterLoad = function () {
        var that = this;

        that.$select_passenger.removeClass(that.class.disabled);
    };

    return ReleaseSeatsPassengersScreen;
})($);
